module.exports = __webpack_public_path__ + "img/paved_default.5f3b2b9b.png";